import { useFormContext } from 'react-hook-form'
import { useDebouncedCallback } from '@/hooks'
import { TextInput } from '@/components/atoms'

export const OrderSourceFilters = () => {
    const { setValue, control } = useFormContext()

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        debouncedSearch(e.target.value)
    }

    const debouncedSearch = useDebouncedCallback((value: string) => {
        setValue('filters.search', value)
        setValue('pagination.currentPage', 1)
    }, 400)

    return (
        <div className="flex items-center">
            <div className="w-full sm:w-64">
                <TextInput
                    control={control}
                    name="filtersForm.search"
                    label=""
                    placeholder="Search sources"
                    onChange={handleSearchChange}
                    className="w-full space-y-0"
                />
            </div>
        </div>
    )
}
